import {Grid} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import * as React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {GPLU_ACDB_FIELD_ID, GPLUCoverageCode} from '../../../PlanTemplates/GWL/gpluConstants';
import {getGPLURatingBlockPropertyPaths} from '../PropertyPaths';

export const getParentPath = (planIndex: number = 0, coverageIndex: number = 0) =>
  `benefitPackagingDetail.plans[${planIndex}].coverageDefs[${coverageIndex}]`;

export const GPLUAccelDeathRatingBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = getGPLURatingBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: '41a0089b-7de3-4b92-8a0b-6e470dce8ba0'},
      items: [
        {
          key: propertyPaths.rateFormatCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="Rate Format"
              id={propertyPaths.rateFormatCd}
              value={getQuoteFieldValue(propertyPaths.rateFormatCd)}
              onChange={e => updateQuoteFieldValue(propertyPaths.rateFormatCd, e.target.value)}
              dropdownVariant="AttributeValue"
              searchKey="GPLUBenefitCoverageRatingDetails.rateFormatCd"
              formFieldId={GPLU_ACDB_FIELD_ID.rateFormatCd}
              coverageCode={GPLUCoverageCode.WHOLE_LIFE}
              required
              disabled
            />
          ),
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Rating" collapsible withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
